import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Landing } from "./landing.model";

@Injectable()
export class LandingService extends CrudService {
  getRootUrl(): string {
    return "landings";
  }

  save(landing: Landing) {
    return super.save(landing);
  }

  saveMultiple(landings: Array<Landing>) {
    return super.saveMultiple(landings);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/landings/shared/landing.service.ts